export const DOMAINS_NAMES = {
  ACCOUNT: 'ACCOUNT',
  CHECKOUT: 'CHECKOUT',
  ECOMMERCE: 'ECOMMERCE',
  DEDICATED: 'DEDICATED-WL',
  LOUNGE_PORTAL: 'LOUNGE-PORTAL',
} as const;

export const ACCOUNT_URLS = {
  HOME: '/',
  MANAGE_BOOKING: 'manage-booking/',
  SEARCH_BOOKING: 'search-booking/',
  LOGIN: 'login/',
  CALLBACK: 'callback',
} as const

export const ECOMMERCE_URLS = {
  HOME: '/',
  MANAGE_BOOKING: 'manage-booking/',
  MODIFY: '/manage-booking/modify/',
  SEARCH: '/search',
  TRAVEL_EXTRAS: '/travel-extras',
  PRODUCT_EXTRAS: '/select-extras/product',
} as const

export const CHECKOUT_URLS = {
  BOOKING: 'checkout/',
  BOOKING_LOUNGES: 'checkout-lounges/',
  MODIFY: 'modify-checkout/',
} as const

export const MANAGE_BOOKING_URLS = {
  BOOKING_SEARCH: '/search/',
  BOOKING_SEARCH_LOUNGES: '/search-lounges/',
  BOOKING_RECEIPT: '/receipt/',
  SELECT_EXTRAS: '/select-extras/',
  MODIFY_SEARCH: '/manage-booking/modify/',
  MODIFY_RECEIPT: '/manage-booking/receipt/',
  MANAGE_BOOKING: '/manage-booking/',
} as const

export const DEDICATED_URLS = {
  ECOM_HOME: '/dedicated',
  CHECKOUT_BOOKING: 'dedicated/checkout/',
  CHECKOUT_BOOKING_LOUNGES: 'dedicated/checkout-lounges/',
  CHECKOUT_MODIFY: 'dedicated/modify-checkout/',
} as const

export const BOOKING_PORTAL_URLS = {
  CHECKOUT: 'booking-portal/checkout/',
  MODIFY_CHECKOUT: 'booking-portal/modify-checkout/',
} as const
export const LOUNGE_PORTAL_URLS = {
  HOME: '/lounge-portal',
  SEARCH: 'lounge-portal/search',
  CHECKOUT: 'lounge-portal/checkout/',
  RECEIPT: 'lounge-portal/receipt/',
} as const;
